// src/pages/backoffice/MenuCategoryFormModal.jsx
import React, { useState } from "react";
import Swal from "sweetalert2";
import { getApiClient } from "../../libs/axiosInstance";

const axios = getApiClient();

export default function MenuCategoryFormModal({ initial, menuId, onClose, onSaved }) {
  const [name, setName] = useState(initial.name || "");
  const [subtitle, setSubtitle] = useState(initial.subtitle || "");
  const [sortOrder, setSortOrder] = useState(initial.sortOrder || 0);
  const [isActive, setIsActive] = useState(initial.isActive ?? true);
  const isEdit = Boolean(initial._id);

  async function handleSave() {
    if (!name.trim()) {
      Swal.fire("Category name required", "", "warning");
      return;
    }

    try {
      if (isEdit) {
        await axios.put(`/api/myshop/categories/${initial._id}`, {
          name,
          subtitle,
          sortOrder,
          isActive,
        });
      } else {
        await axios.post(`/api/myshop/menus/${menuId}/categories`, {
          name,
          subtitle,
          sortOrder,
          isActive,
        });
      }

      Swal.fire("Saved", "Category saved successfully", "success");
      onSaved?.();
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Save failed", "error");
    }
  }

  return (
    <div className="modal d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-sm modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h6 className="modal-title">
              {isEdit ? "Edit Category" : "New Category"}
            </h6>
            <button className="btn-close" onClick={onClose} />
          </div>

          <div className="modal-body" style={{ fontSize: "13px" }}>
            <div className="mb-2">
              <label className="form-label">Name</label>
              <input
                className="form-control form-control-sm"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div className="mb-2">
              <label className="form-label">Subtitle (optional)</label>
              <input
                className="form-control form-control-sm"
                value={subtitle}
                onChange={(e) => setSubtitle(e.target.value)}
              />
            </div>

            <div className="mb-2">
              <label className="form-label">Sort Order</label>
              <input
                type="number"
                className="form-control form-control-sm"
                value={sortOrder}
                onChange={(e) => setSortOrder(Number(e.target.value))}
              />
            </div>

            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
              />
              <label className="form-check-label">Active</label>
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary btn-sm" onClick={onClose}>
              Cancel
            </button>
            <button className="btn btn-primary btn-sm" onClick={handleSave}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
